import { render, staticRenderFns } from "./inspection-questions-classification-chart.component.vue?vue&type=template&id=8dbe8e76&scoped=true"
import script from "./inspection-questions-classification-chart.component.ts?vue&type=script&lang=ts&external"
export * from "./inspection-questions-classification-chart.component.ts?vue&type=script&lang=ts&external"
import style0 from "./inspection-questions-classification-chart.component.vue?vue&type=style&index=0&id=8dbe8e76&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbe8e76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dbe8e76')) {
      api.createRecord('8dbe8e76', component.options)
    } else {
      api.reload('8dbe8e76', component.options)
    }
    module.hot.accept("./inspection-questions-classification-chart.component.vue?vue&type=template&id=8dbe8e76&scoped=true", function () {
      api.rerender('8dbe8e76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/charts/inspection-questions-classification-chart.component.vue"
export default component.exports